import { Image, ImageProps } from 'theme-ui'

const Dinero = (props: ImageProps) => {
  return <Image width={16} src="/imgs/dinero.png" {...props} />
}
export default Dinero
